import { Time } from '../types'

/**
 * Represents a time with null hour and minute values.
 * Used as a default or placeholder value in the time widget.
 */
export const nullTime: Time = { hour: null, minute: null }
